<template>
  <!-- modal-append-to-body -->
  <el-dialog
    title="影院选择"
    width="900px"
    :visible="value"
    :close-on-click-modal="false"
    top="40px"
    append-to-body
    class="partial"
    @close="onCancel"
    custom-class="import-dialog"
  >
    <div class="cinemaContent-top">
      <el-radio v-model="cinemaFilterType" :label="0">默认所有影院</el-radio>
      <span class="cinemaContent-botm-text">指适用小程序展示的所有影院</span>
    </div>

    <div class="cinemaContent-botm">
      <div>
        <el-radio v-model="cinemaFilterType" :label="1">指定影院可用</el-radio>
      </div>
      <span>已选中：{{ len }}</span>
      <div class="cinemaContent-top-r">
        <div class="cinemaContent-top-search">
          <div class="cinemaContent-top-search-text">影院名称</div>
          <el-input
            v-model="searchForm.cinemaName"
            placeholder="请输入"
            style="width: 220px"
            clearable
          >
          </el-input>
        </div>
        <div>
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
        </div>
      </div>
      <!-- <el-form inline :model="searchForm">
        <el-form-item label="影院名称">
          <el-input
            v-model.trim="searchForm.cinemaName"
            :max-length="200"
            placeholder="请输入影院名称"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onFormSearch">查询</el-button>
          <el-button @click="onFormReset">重置</el-button>
        </el-form-item>
      </el-form> -->
    </div>

    <!-- <div
      v-if="table.dataSource && table.dataSource.length"
      class="partial-toolbar"
    >
      <el-checkbox
        v-model="checkedAll"
        :disabled="!filterTableList.length"
        @change="onCheckedAll"
        >全选所有<span class="partial-tip__red"
          >（列表仅显示有达人关联的代理）</span
        ></el-checkbox
      >
    </div> -->
    <!-- tooltip-effect="dark" -->
    <el-table
      ref="table"
      v-loading="table.loading"
      :data="table.dataSource"
      border
      lazy
      row-key="id"
      :header-cell-class-name="cellClass"
      @selection-change="onSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="selectable" />
      <el-table-column
        align="center"
        label="编号"
        type="index"
        width="50"
        :index="indexMethodss"
      >
      </el-table-column>
      <!-- <el-table-column prop="id" label="ID" width="100" /> -->
      <el-table-column prop="name" label="分类名称" width="250"/>
      <!-- :show-overflow-tooltip="true" -->
      <el-table-column
        prop="cinemaName"
        label="影院名称"
        :show-overflow-tooltip="true"
      >
        <!-- <template slot-scope="{row}">
          <div slot="tooltip-content" style="max-width:200px">{{row.cinemaName}}</div>
        </template> -->
      </el-table-column>
    </el-table>

    <!-- 分页-->
    <el-pagination
      v-if="table.total"
      class="table-pagination"
      @size-change="onSizeChange"
      @current-change="onCurrentChange"
      :current-page.sync="pagination.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="table.total"
    />
    <div style="text-align: right;margin-top:15px;">
              <el-button type="warning" @click="onSure"
                >确认选择</el-button
              >
            </div>
    <!-- <span slot="footer" class="partial-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onSure">确认</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import pagination from "@/components/Pagination";

import mini from "@/api/mini";
const MiniModel = new mini();
const searchParams = {
  cinemaName: "", // 代理名称
};
export default {
  components: {
    pagination, // 分页
  },
  props: {
    value: {
      // 是否显示弹框
      type: Boolean,
      default: false,
    },
    ids: {
      // 已选中的
      type: Array,
      default: () => [],
    },
    types:{
      type: Number,
      default:0
    }
  },
  data() {
    return {
      //筛选影院
      cinemaForm: {
        cinemaName: "",
        pageNo: 1,
        pageSize: 10,
      },
      cinemaFilterType: 0, //0:全部影院 1:指定影院分类
      multipleSelection: [], // 表格选中
      checkedAll: false, // 全选所有
      table: {
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
      searchForm: Object.assign({}, searchParams), // 搜索数据
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      filterTableList: [], // 过滤的表格
      cinemaList: [], // 代理列表
      len:0
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: async function (val, oldVal) {
        if (val) {
          await this.freshList();
          this.setSelectionChange();
          // this.len = this.multipleSelection.length
        }
        
        this.cinemaFilterType = this.types
        console.log(this.types,'typestypes')
      },
    },
    cinemaFilterType: {
      // immediate: true,
      handler (val, oldVal) {
        console.log(val, oldVal,'NNN')
        if (val) {
          this.len = this.multipleSelection.length
          console.log('AA')
          // this.freshList();
          // this.setSelectionChange();
        }else{
          console.log('BB')
          this.len = 0
          // this.onCheckedAll(false)
        }
        console.log(val,'cinemaFilterType')
      },
    },
  },
  computed: {
    indexMethodss: function () {
      return (this.pagination.pageNo-1) *this.pagination.pageSize +1
    },
  },
  methods: {
    // 隐藏全选
    cellClass() {
      if (this.cinemaFilterType === 0) {
        return "DisableSelection";
      }
    },
    // 禁用勾选
    selectable() {
      if (this.cinemaFilterType) {
        return true;
      } else {
        return false;
      }
    },
    // 取消
    onCancel() {
      this.$emit("close", false);
    },
    // 确定
    onSure() {
      console.log(this.multipleSelection,'multipleSelection选中')
      // if(this.cinemaFilterType && this.ids.length > 0) {
      //   this.onCancel();
      // }else{
      //   this.$message.error("请选择影院");
      // }
      if (this.cinemaFilterType && this.multipleSelection.length == 0) {
        this.$message.error("请选择影院");
        return;
      }
      if (this.cinemaFilterType && this.multipleSelection && this.multipleSelection.length) {
        console.log('radio为1确定')
        this.$emit("selectCinema", this.multipleSelection,this.cinemaFilterType);
        this.onCancel();
      }else{
        let arr = []
        console.log('dadio为0确定了',this.multipleSelection)
        this.$emit("selectCinema", arr,this.cinemaFilterType);
        this.onCancel();
      }
      
      
      // else {
      //   this.$message.error("请至少选择一个代理");
      // }
    },
    // 搜索查询
    onFormSearch() {
      this.pagination.pageNo = 1;
      this.freshTable();
      const multipleIds = this.multipleSelection.map((item) => item.id);
      const filterIds = this.filterTableList.map((item) => item.id);
      // 选中的是否包含过滤出来的
      const diffList = multipleIds.filter(
        (item) => filterIds.indexOf(item) > -1
      );
      if (this.filterTableList && this.filterTableList) {
        this.checkedAll = diffList.length === filterIds.length;
      } else {
        this.checkedAll = false;
      }
    },
    // 搜索重置
    onFormReset() {
      this.searchForm = Object.assign({}, searchParams);
      this.pagination.pageNo = 1;
      this.freshTable();
      // this.setSelectionChange();
      // this.onCheckedAll(false);
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 全选所有
    async onCheckedAll(value) {
      await this.$nextTick();
      this.filterTableList.forEach(async (item) => {
        this.$refs.table.toggleRowSelection(item, value);
      });
    },
    // 设置表格选中
    async setSelectionChange() {
      this.$refs.table && this.$refs.table.clearSelection();
      console.log(this.ids, "this.idsthis.ids父传子");
      if (this.ids && this.ids.length) {
        // const ids = this.ids.map((item) => item.id);
        this.cinemaList.forEach(async (item) => {
          await this.$nextTick();
          if (this.ids.includes(item.id)) {
            this.$refs.table.toggleRowSelection(item, true);
          }
        });
      }
    },
    // 表格选择
    onSelectionChange(arr) {
      console.log(arr,'表格选择')
      this.multipleSelection = arr;

      // 有查询条件的时候
      if (
        this.filterTableList &&
        this.filterTableList.length &&
        this.filterTableList.length !== this.cinemaList.length
      ) {
        this.checkedAll = arr.length === this.filterTableList.length;
      } else {
        this.checkedAll = arr.length === this.cinemaList.length;
      }
      console.log(this.cinemaFilterType,'CC')
      if(this.cinemaFilterType) {
        this.len = this.multipleSelection.length
      }else{
        this.len = 0
      }
    },
    // 计算表格数据
    freshTable() {
      this.table.loading = true;
      let list = [...this.cinemaList];
      list = list.filter(
        (item) =>
          item.cinemaName &&
          item.cinemaName.indexOf(this.searchForm.cinemaName) > -1
      );

      this.filterTableList = list;

      this.table.dataSource = list.slice(
        (this.pagination.pageNo - 1) * this.pagination.pageSize,
        this.pagination.pageNo * this.pagination.pageSize
      );
      this.table.total = list.length;
      this.table.loading = false;
    },
    // 请求表格
    async freshList() {
      this.table.loading = true;
      const res = await MiniModel.cinemaClassifyList({
        pageNo: 1,
        pageSize: 150,
      }).finally(() => {
        this.table.loading = false;
      });

      if (res.data.code === 200) {
        console.log(res.data, " res.data res.data res.data");
        console.log(res.data.data.list, "res.data.data.list");
        this.cinemaList = res.data.data.list.map((item) => ({
          ...item,
          id: item.id.toString(),
        }));

        this.freshTable();
      } else {
        this.$message.error(res.data.message || res.data.info);
      }
    },
  },
};
</script>
<style lang="less" scoped>
// 弹出层的高度
/deep/.el-dialog.import-dialog {
  max-height: 830px !important;
  // max-height: 800px;
  overflow-y: auto;
  // margin: auto !important;
}
/deep/.el-table .DisableSelection .cell .el-checkbox__inner {
  display: none;
}
.cinemaContent-top {
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 15px;
}
.cinemaContent-botm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .cinemaContent-botm-text {
    margin-left: -20px;
    color: #999999;
    font-size: 14px;
    margin-right: 25px;
  }
  .cinemaContent-top-r {
    display: flex;
    .cinemaContent-top-search {
      display: flex;
      margin-right: 20px;
      align-items: center;
      .cinemaContent-top-search-text {
        margin-right: 10px;
      }
    }
  }
}
// .partial {
//   height: 780px;
//   &-toolbar {
//     padding: 0 10px;
//     margin-bottom: 20px;
//   }

//   &-tip {
//     color: #999;

//     &__red {
//       color: red;
//     }
//   }

//   &-ratio {
//     width: 20%;
//   }
// }
// /deep/.el-tooltip__popper{
//   max-width: 300px !important;
// }
</style>





// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/coupon/FilterCinema.vue